module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer.121af889919d74859a09072cf869bf44.png";